export const getLoginDetails = (state) => state.Logindetails;
export const getUserProfileDetails = (state) => state.UserProfileDetails;
